export const AddressSource = Object.freeze({
    ServerAddress: 1,
    ManualAddress: 2,
    MigrosLoginAddress: 3
});

export const EquipmentSource = Object.freeze({
    ServerEquipment: 1,
    ManualEquipment: 2
});

export const Salutations = Object.freeze({
    Company: 1,
    Mrs: 2,
    Mr: 3
});

export const DeliveryPeriodTypes = Object.freeze({
    Prompt: 1,
    Period: 2,
    Express: 3
});

export const PriceTypes = Object.freeze({
    Total: 1,
    Unit: 2
});

export const PaymentModes = Object.freeze({
    SingleUP: 'SingleUP',
    OnePaysAll: 'OnePaysAll',
    EveryonePaysSeparate: 'EveryonePaysSeparate',
    Other: 'Other'
});

export const ErrorMessageTypes = Object.freeze({
    Unknown: 0,
    CouponInvalid: 1,
    ModelValidation: 2,
    OfferInvalid: 3
});

export const PriceRequestOutcomes = Object.freeze({
    Unexpected: 0,
    PriceCalculated: 1,
    ZipCodeInvalid: 2,
    CouponInvalid: 3,
    ManualPricing: 4
});

export const FindEquipmentstOutcomes = Object.freeze({
    Unexpected: 0,
    Success: 1
});

export const CreateOfferOutcomes = Object.freeze({
    Unexpected: 0,
    AutomaticOffer: 1,
    Interaktionsformular: 2,
    InvalidCoupon: 3,
    PricesExpired: 4,
    ShopDisabled: 5
});

export const CreateOrderOutcomes = Object.freeze({
    Unexpected: 0,
    AutomaticOrder: 1,
    Interaktionsformular: 2,
    OfferExpired: 3,
    OfferAlreadyOrderedOn: 4,
    OfferNotFound: 5,
    PricesExpired: 6,
    ShopDisabled: 7
});

export const PostOrderDataOutcomes = Object.freeze({
    Unexpected: 0,
    Saved: 1
});